import { Component, inject, OnInit } from '@angular/core';
import { Title } from '@angular/platform-browser';

import {MessageService} from "./shared/services/message.service";
import { TranslocoService } from '@jsverse/transloco';
import { KindergartenService } from '@app/core/services/kindergarten.service';
import { switchMap } from 'rxjs/operators';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
    standalone: false
})
export class AppComponent implements OnInit {
  private readonly titleService = inject(Title);
  private readonly translocoService = inject(TranslocoService);
  private readonly messageService = inject(MessageService);
  private readonly kindergartenService = inject(KindergartenService);

  public constructor() {
    this.messageService.initMessageListener();
  }

  ngOnInit(): void {
    this.kindergartenService.kindergarten$
      .pipe(
        switchMap((kindergarten) => {
          const key = kindergarten?.isDemo ? 'demo/title' : 'shared/appTitle';
          return this.translocoService.selectTranslate(key);
        })
      )
      .subscribe((translatedTitle) => {
        this.titleService.setTitle(translatedTitle);
      });
  }
}
